import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import {
  Add_Regions,
  Delete_one_Regions,
  Get_All_Regions,
  Get_Error,
  Get_one_Regions,
  Update_one_Regions,
} from '../Types';
import usegetdata from '../../Hooks/useGetData';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';

//add all cities data
export const Add_regions_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/regions`, body);

    dispatch({
      type: Add_Regions,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const GetAllRegionsData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/regions?active=true`);

    dispatch({
      type: Get_All_Regions,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const GetAllRegionsDataTrash = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/regions?active=false`);

    dispatch({
      type: Get_All_Regions,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one region data
export const DeleteOneregionData = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/regions/${id}`);

    dispatch({
      type: Delete_one_Regions,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one city data
export const UpdateOneRegionData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/regions/${id}`, body);

    dispatch({
      type: Update_one_Regions,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one cities data
export const GetOneRegionsData = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/regions/${id}`);

    dispatch({
      type: Get_one_Regions,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
